export default __webpack_public_path__ + "static/media/share.d047501b.svg";